module.exports = __webpack_public_path__ + "static/media/PH.24ed833a.png";